import { Component, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as moment from 'moment';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { startWith, takeUntil, tap } from 'rxjs/operators';
import { SelfDestruct } from 'src/shared/utilities/self-destruct';

export interface PayrollMonthlyReportArgs {
	jobId?: number;
	startDate?: string | moment.Moment;
	filename?: string;
}

export interface PayrollMonthlyReportDialogData {
	jobId?: number;
}

@Component({
	selector: 'rpfsa-payroll-monthly-report-dialog',
	templateUrl: './payroll-monthly-report-dialog.component.html',
	styleUrls: ['./payroll-monthly-report-dialog.component.scss'],
})
export class PayrollMonthlyReportDialogComponent extends SelfDestruct {
	readonly payrollMonthlyReportArgs = new BehaviorSubject<
		PayrollMonthlyReportArgs
	>(undefined);
	readonly isValid = new BehaviorSubject<boolean>(false);
	readonly defaultFilename = `${moment
		.utc()
		.local()
		.format('YYYY-MM-DD_HH-mm')}_Payroll_Monthly_Report.csv`;

	startDate = new FormControl(['', Validators.required]) as FormControl;
	filename = new FormControl(this.defaultFilename) as FormControl;

	readonly onChange$ = combineLatest([
		this.startDate.valueChanges,
		this.filename.valueChanges.pipe(startWith(this.defaultFilename)),
	])
		.pipe(
			tap(([sd, fn]) => {
				this.payrollMonthlyReportArgs.next({
					startDate:
						sd || this.payrollMonthlyReportArgs.value.startDate,
					filename:
						fn || this.payrollMonthlyReportArgs.value.filename,
					jobId: this.payrollMonthlyReportArgs.value.jobId,
				});
				if (!!sd && !!fn) {
					this.isValid.next(true);
				} else {
					this.isValid.next(false);
				}
			}),
			takeUntil(this.destroyed)
		)
		.subscribe();

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: PayrollMonthlyReportDialogData
	) {
		super();
		if (data.jobId !== undefined && data.jobId !== null) {
			this.payrollMonthlyReportArgs.next({
				jobId: data.jobId,
			});
		}
	}
}
